import ISiteDiaryAuthorisedMaintenance from "interfaces/SiteDiary/AuthorisedMaintenance/ISiteDiaryAuthorisedMaintenance";
import { InfoCircleFill } from "react-bootstrap-icons";

const DetailsTemplate = (props: ISiteDiaryAuthorisedMaintenance): any => {
  const { id, details } = props;

  return (
    <>
      {details && details !== "" && <InfoCircleFill data-testid={`${id}-info`} />}
    </>
  );
};
export default DetailsTemplate;
